/**
 * OdysseyModelEngine enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file OdysseyModelEngine.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum OdysseyModelEngine {
  K1      = 0x0001,
  K2      = 0x0002,
  K1_XBOX = 0x0004,
  K2_XBOX = 0x0008
};